import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/fold2/BgImg05.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>
                Precisely Customized Solutions for Your Business Digitization
              </h2>
            </div>
            <p>
              Having a grip on both iOS and Android app development in
              Indianapolis, we serve businesses with full-fledged solutions
              based on efficient customization. Our skilled mobile app
              developers are experts in building B2B and B2C apps, each
              providing a smooth user experience with high functionality.
            </p>
            <p>
              We customize our strategy that fit properly with your business
              framework. That’s how we design the apps considering the
              preferences of your target audience. So, you can easily consider
              us as your reliable Indianapolis app development company.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
